module.exports = __webpack_public_path__ + "img/p54.89eb1e4b.png";